import React from 'react';
import { Accordion, Card, useAccordionToggle } from 'react-bootstrap';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useContext } from 'react';
import { FLAGS_EXCEED_MESSAGE, FLAGGED_PLAYERS_LIMIT } from '../../../../../config/constants';
import { message } from 'antd';
import { useTablePropertiesDispatch, useTablePropertiesState } from 'store/hooks';

const ContextAwareToggle = ({ children, eventKey, callback, hasMetrics, handleAccordionExpand, ...rest }) => {
  const currentEventKey = useContext(AccordionContext);

  const handleAccordionClick = () => {
    callback && callback(eventKey);
    handleAccordionExpand();
  };

  const decoratedOnClick = useAccordionToggle(
    eventKey,
    () => handleAccordionClick()
  );

  const isCurrentEventKey = currentEventKey === eventKey;

  return (
    <td {...rest} onClick={hasMetrics ? decoratedOnClick : () => {}}>
      {children}
      {hasMetrics && <i className={'mdi ' + (isCurrentEventKey ? 'mdi-chevron-up' : 'mdi-chevron-down')} />}
    </td>
  );
};

const AccordionRow = ({ player, children, expandedAcc, hasMetrics, handleAccordionExpand }) => {

  const { pinnedRows = [] } = useTablePropertiesState();
  const { changePinnedRows } = useTablePropertiesDispatch();

  const isPlayerPinned = pinnedRows.includes(player.playerId);

  const handleFlagClicked = () => {
    const unmutedRows = [...pinnedRows];
    if (isPlayerPinned) {
      const index = pinnedRows.indexOf(player.playerId);
      unmutedRows.splice(index, 1);

      if (expandedAcc) {
        handleAccordionExpand();
      }
    } else {
      if (pinnedRows.length < FLAGGED_PLAYERS_LIMIT) {
        unmutedRows.push(player.playerId);
      } else {
        message.warning({
          content: FLAGS_EXCEED_MESSAGE,
          className: 'pv-antd-message-alert'
        });
      }
    }
    changePinnedRows(unmutedRows)();
  };

  const handleSelectedClass = className => {
    return isPlayerPinned ? `${className} player-selected` : className;
  };

  return (
    <Accordion className="accordion">
      <Card>
        <Card.Header className="accordion-card-header">
          <table>
            <thead style={{ border: 'none' }}>
              <tr className="accordion-header">
                <td 
                  onClick={handleFlagClicked}
                  className={handleSelectedClass("")}  
                  style={{ width: '40px', paddingLeft: 20, paddingRight: 20, cursor: 'pointer' }}
                >
                  <img
                    src={isPlayerPinned ? "/assets/flag-03.svg" : "/assets/flag-02.svg"}
                    height="13" width="13" alt="icon" />
                </td>
                <ContextAwareToggle 
                  eventKey="0" 
                  hasMetrics={hasMetrics}
                  style={isPlayerPinned ? { color: '#007ABA' } : {}}
                  className={handleSelectedClass("player-name")}
                  handleAccordionExpand={handleAccordionExpand}
                >
                  <b>{player.name}</b>
                </ContextAwareToggle>
                <td className={handleSelectedClass("metric-td")}>{player.metrics && player.metrics.accelMed > 0 ? player.metrics.accelMed : 0}</td>
                <td className={handleSelectedClass("metric-td")}>{player.metrics && player.metrics.accelFast > 0 ? player.metrics.accelFast : 0}</td>
                <td className={handleSelectedClass("metric-td")}>{player.metrics && player.metrics.decelMed > 0 ? player.metrics.decelMed : 0}</td>
                <td className={handleSelectedClass("metric-td")}>{player.metrics && player.metrics.decelFast > 0 ? player.metrics.decelFast : 0}</td>
              </tr>
            </thead>
          </table>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className="accordion-card-body">
            {children}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default AccordionRow;